// Service worker registration (DevRobot UI kit): the shell opens offline from the Home Screen,
// and a new build asks before reloading.

import { registerSW } from 'virtual:pwa-register';
import { toast } from '../components/Toaster';
import { setPushRegistration, syncSubscription } from './push';

const STICKY = 2 ** 31 - 1; // longest delay setTimeout accepts: the toast stays until acted on

export function initPwa() {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;

  const update = registerSW({
    onNeedRefresh() {
      toast('A new version of DevRobot is ready', {
        description: 'Reload to get the latest administrator.',
        tone: 'info',
        duration: STICKY,
        haptic: false,
        action: { label: 'Reload', onClick: () => void update(true) },
      });
    },
    // Look for a new build whenever the app comes back to the foreground, as native apps do.
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setPushRegistration(registration);
      // Safari and Firefox rotate a push subscription without firing pushsubscriptionchange,
      // so every launch re-checks whether this device's endpoint still matches.
      void syncSubscription();
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && navigator.onLine) registration.update().catch(() => {});
      });
    },
  });
}
